import type { ComponentType } from "react";
import { Navigate } from "react-router-dom";

import { useUse2026UI } from "../../hooks/useUse2026UI";

export const versioned = (
  LegacyComponent: ComponentType,
  Ui2026Component: ComponentType
): ComponentType => {
  const VersionedRoute = () => {
    const use2026UI = useUse2026UI();
    const Component = use2026UI ? Ui2026Component : LegacyComponent;
    return <Component />;
  };
  return VersionedRoute;
};

export const only2026 = (Ui2026Component: ComponentType): ComponentType => {
  const Ui2026Route = () => {
    const use2026UI = useUse2026UI();
    return use2026UI ? (
      <Ui2026Component />
    ) : (
      <Navigate to="/dashboard" replace />
    );
  };
  return Ui2026Route;
};
